/**
 * Version stamp for the marketing-consent text shown at signup.
 *
 * Stored on `profiles.marketing_consent_text_version` alongside the timestamp
 * and IP, so we can always answer "what exact wording did this user agree to?"
 * — required by GDPR Art. 7(1) (controller must demonstrate consent) and useful
 * defense evidence under IL Communications Law §30A class actions.
 *
 * Bump this **every time** the displayed consent text changes (in any locale).
 */
export const MARKETING_CONSENT_TEXT_VERSION = "v1";
